export const permissionConstants = {
	assignedLoansOnly: "assigned_loans_only",
	allLoans: "all_loans",
	readOnlyLoans: "read_loans", //read only loans
	allProperties: "all_properties",
	assignedPropertiesOnly: "assigned_properties_only",
	approveDraw150k: "approve_draw_150k",
	approveLoan: "approve_loan",
	uploadDoc: "upload_doc_loan",
	loanAccountStatement: "loan_account_statements",
	viewAnalytics: "view_analytics",
	// Checklist
	addChecklist: "add_checklist",
	editChecklist: "edit_checklist",
	deleteChecklist: "delete_checklist_items",
	//
	viewPayments: "view_payments",
	viewAllBorrowers: "view_all_borrowers",
	viewAllDocuments: "view_all_documents",
	editAndUpload: "edit_and_upload_documents",
	downloadDocuments: "download_documents",
	viewLoanFields: "view_loan_fields",
	editBranding: "edit_branding",
	editUserRolesPermissions: "edit_user_roles_and_permissions",
	deleteUserRolesPermissions: "delete_user_roles_and_permissions",
	viewUserRolesPermissions: "view_user_roles_permissions",
	editBorrower: "edit_borrower",
	deleteLoan: "delete_loan",
	deleteDraw: "delete_draw",
	// Tasks
	viewTaskPanel: "view_task_panel",
	addTasks: "add_tasks",
	editTasks: "edit_tasks",
	viewTasks: "view_tasks",
};

export const isPermissionEnabled = (user: any): boolean => {
	const isLender = user.type === "lender";

	const companyConfig = isLender
		? user.company.company_configurations[0]
		: user.lender_company.company_configurations[0];

	const permissionsEnabled =
		companyConfig?.roles_permissions.permissionsenabled;

	return permissionsEnabled === true || permissionsEnabled === "true";
};

export const hasPermission = (user: any, permissionName: any): boolean => {
	// If user has no role or no permissions defined, allow all actions by default
	if (
		!user?.role?.role_permissions ||
		user.role.role_permissions.length === 0
	) {
		return true;
	}

	// Check if permissions are enabled for this user
	const permissionEnabled = isPermissionEnabled(user);

	if (!permissionEnabled) {
		return false;
	}

	// Check if user has the specific permission enabled
	const existsPermission: boolean = user.role.role_permissions.some(
		(rolePermission: any) => {
			const permissionMatches =
				rolePermission?.permissions?.permission_name === permissionName;
			const isPermissionActive =
				rolePermission?.is_active === true ||
				rolePermission?.is_active === "true";
			return permissionMatches && isPermissionActive;
		}
	);

	// User must have both permissions enabled globally and the specific permission
	return existsPermission;
};

export const newLoanAppPermission = (user: any) => {
	let permissionValue = true;
	if (user.type === "lender") {
		permissionValue = true;
	} else if (user.type === "borrower") {
		permissionValue =
			user?.lender_company?.company_configurations?.[0]?.roles_permissions
				?.newloanapp;
	}
	return permissionValue || true;
};

/**
 * @deprecated The method should not be used, use permissionHelper instead
 */
export const checkDisability = (user: any, permissionName: any) => {
	if (user.type === "lender") {
		const roles_permissions =
			user?.company?.company_configurations[0]?.roles_permissions;
		if (roles_permissions && roles_permissions[permissionName]) {
			return true;
		}
	} else if (user.type === "borrower") {
		const roles_permissions =
			user?.lender_company?.company_configurations[0]?.roles_permissions;
		if (roles_permissions && roles_permissions[permissionName]) {
			return true;
		}
	}
	return false; //give the optional value here
};

/**
 * @deprecated The method should not be used, use permissionHelper instead
 */
export const checkEnability = (user: any, permissionName: any) => {
	if (user.type === "lender") {
		const roles_permissions =
			user?.company?.company_configurations[0]?.roles_permissions;
		if (roles_permissions && roles_permissions[permissionName]) {
			return false;
		}
	} else if (user.type === "borrower") {
		const roles_permissions =
			user?.lender_company?.company_configurations[0]?.roles_permissions;
		if (roles_permissions && roles_permissions[permissionName]) {
			return false;
		}
	}
	return true; //give the optional value here
};

export const getInterestRateCalRwa = (user: any) => {
	if (user.type === "lender") {
		const interestRatePermission =
			user?.company?.company_configurations?.[0]?.field_controls?.interest_rate;
		if (interestRatePermission) {
			return true;
		}
	} else if (user.type === "borrower") {
		const interestRatePermission =
			user?.lender_company?.company_configurations?.[0]?.field_controls
				?.interest_rate;
		if (interestRatePermission) {
			return true;
		}
	}
	return false;
};
